import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id EFDF1C9C-3566-4312-ACBC-AC5B10EA28DE
 * name home-battery-outline
 * version: 6.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-battery-outline.svg
 * tags
 * - Home Automation 
 * - Battery 
 */
export const HomeBatteryOutlineIcon = createSvgIcon(<><path d="M15 9H16V7.5H20V9H21C21.55 9 22 9.45 22 10V21C22 21.55 21.55 22 21 22H15C14.45 22 14 21.55 14 21V10C14 9.45 14.45 9 15 9M16 11V14H20V11H16M12 5.69L7 10.19V18H12V20H5V12H2L12 3L14.78 5.5H14V7.17L13.76 7.27L12 5.69Z" /></>, 'HomeBatteryOutlineIcon');
export default HomeBatteryOutlineIcon